import {connect} from 'react-redux';

import {LegacyPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {getCompanyUrl} from '../../../store/data/company/companySelectors';
import {getUser} from '../../../store/data/teammates/teammatesSelectors';
import {getTeamsByNamespace, getTeamsUserIsAdminOf} from '../../../store/data/teams/teamsSelectors';
import {makeGetOptionalLegacyPath} from '../../../store/panels/legacy/legacyPanelSelectors';
import {getRuleParametersDependencies} from '../../../store/settings/settingsRulesSelectors';
import {makeGetSettingsTypeTrackingField} from '../../../store/settings/settingsTrackingSelectors';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {SettingsSearchBar} from './settingsSearchBar';

/*
 * Props.
 */

interface SettingsTopbarSearchContainerProps {
  panelId: LegacyPanelId;
}

/*
 * Selectors.
 */

function getLegacyPanelId(_state: AppState, props: SettingsTopbarSearchContainerProps) {
  return props.panelId;
}

/*
 * Redux.
 */

const getLocationPathAndQuery = makeGetOptionalLegacyPath(getLegacyPanelId);

const getLocationPathAndQueryString = (state: AppState, props: SettingsTopbarSearchContainerProps) =>
  getLocationPathAndQuery(state, props) ?? '';

const mapStateToProps = makeMapStateToProps<SettingsTopbarSearchContainerProps>()(() => ({
  teamsMap: getTeamsByNamespace,
  user: getUser,
  companyUrl: getCompanyUrl,
  settingsTypeTrackingField: makeGetSettingsTypeTrackingField(getLocationPathAndQueryString),
  teamsUserIsAdminOf: getTeamsUserIsAdminOf,
  ruleParametersDependencies: getRuleParametersDependencies,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const SettingsSearchBarContainer = connect(mapStateToProps, mapDispatchToProps)(SettingsSearchBar);
